import React from 'react'
import { is } from 'ramda'
import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { SmallText } from '../../packages/kiti/components/presentation/Text'
import NumberInput from './NumberInput'

const BetweenValueInput = ({ value, onChange, ...props }) => {
  const [init, end] = is(Array, value) ? value : []

  return (
    <Grid gutter={0.2} align="center">
      <Col>
        <NumberInput
          onStopTyping={v => onChange(v !== undefined ? [parseFloat(v), end] : [v, end])}
          value={init}
          {...props}
        />
      </Col>

      <SmallText>e</SmallText>

      <Col>
        <NumberInput
          onStopTyping={v => onChange(v !== undefined ? [init, parseFloat(v)] : [init, v])}
          value={end}
          {...props}
        />
      </Col>
    </Grid>
  )
}

export default BetweenValueInput
